import styled from 'styled-components';
import { Typography } from '../Typography/Typography';
import { getInitials } from './utils';

const StyledInitialsAvatar = styled.div`
  background-color: var(--grayscale-600);
  color: var(--white);
  border-radius: var(--border-radius-circle);
  display: flex;
  min-width: 32px;
  min-height: 32px;
  justify-content: center;
  align-items: center;
`;

const Initials = styled(Typography)`
  color: var(--white);
`;

export type InitialsAvatarProps = {
  className?: string;
  name: string;
};

/**
 * A circular avatar component that displays up to 2 initials derived from the name.
 */
export const InitialsAvatar = ({ name, className }: InitialsAvatarProps) => {
  return (
    <StyledInitialsAvatar className={className}>
      <Initials renderedAs="span" styledAs="bodySpaceGrotesk" weight={500}>
        {getInitials(name)}
      </Initials>
    </StyledInitialsAvatar>
  );
};

export default InitialsAvatar;
